import api from './api';

export type WalletType = 'CRYPTO' | 'BANK';

export interface Wallet {
  id: number;
  name: string;
  wallet_type: WalletType;
  active: boolean;
  crypto_currency?: string;
  wallet_address?: string;
  bank_details?: string;
  field1?: string;
  field2?: string;
  field3?: string;
  field4?: string;
  field5?: string;
  created_at: string;
  updated_at: string;
}

export interface WalletCreate {
  name: string;
  wallet_type: WalletType;
  active?: boolean;
  crypto_currency?: string;
  wallet_address?: string;
  bank_details?: string;
  field1?: string;
  field2?: string;
  field3?: string;
  field4?: string;
  field5?: string;
}

export interface WalletUpdate {
  name?: string;
  wallet_type?: WalletType;
  active?: boolean;
  crypto_currency?: string;
  wallet_address?: string;
  bank_details?: string;
  field1?: string;
  field2?: string;
  field3?: string;
  field4?: string;
  field5?: string;
}

export const walletsApi = {
  // Получить кошелек по ID
  getWallet: async (walletId: number): Promise<Wallet> => {
    const response = await api.get(`/api/wallets/${walletId}`);
    return response.data;
  },

  // Получить все кошельки
  getWallets: async (
    skip: number = 0,
    limit: number = 100,
    walletType?: WalletType,
    active?: boolean
  ): Promise<Wallet[]> => {
    let url = `/api/wallets?skip=${skip}&limit=${limit}`;
    if (walletType) {
      url += `&wallet_type=${walletType}`;
    }
    if (active !== undefined) {
      url += `&active=${active}`;
    }
    const response = await api.get(url);
    return response.data;
  },

  // Создать кошелек
  createWallet: async (wallet: WalletCreate): Promise<Wallet> => {
    const response = await api.post('/api/wallets', wallet);
    return response.data;
  },

  // Обновить кошелек
  updateWallet: async (walletId: number, wallet: WalletUpdate): Promise<Wallet> => {
    const response = await api.put(`/api/wallets/${walletId}`, wallet);
    return response.data;
  },

  // Удалить кошелек
  deleteWallet: async (walletId: number): Promise<void> => {
    await api.delete(`/api/wallets/${walletId}`);
  }
};

